var React = require('react');
var ReactNative = require('react-native');

var Icon = require('./wrappers/ReUpIcon');

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');
var PriceChooserView = require('./PriceChooserView.js');
var PaymentMethodChooserView = require('./PaymentMethodChooserView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpText = require('./ReUpText');

var {
  AppRegistry,
  Text,
  View,
  Image,
  StyleSheet,
} = ReactNative;

var SendGiftCard = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    var locManager = this.props.appManager.getLocalizationManager();
    var sendButtonStr = locManager.localizedStringForKey("SEND_BUTTON", "Send");
    return {
      layout : this.props.initialLayout,
      message : "",
      numMessageLines : 1,
      messageHeight:50,
      sendButton:"Send",//TODO:localize
      emailError:false,
      nameError:false,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  setScrollOffset: function(yOffset)
  {
    var thisThing = this;
    setTimeout(function()
    {
      var minScrollOffset = 0;
      var keyboardOffset = typeof thisThing._ref_ptr !== 'undefined' ? thisThing._ref_ptr._keyboardOffset : 0;
      var maxScrollOffset = thisThing._contentHeight - (thisThing._scrollViewHeight - keyboardOffset);
      var normalizedScroll = Math.max(minScrollOffset, Math.min(maxScrollOffset, yOffset));

      thisThing._ref_ptr.scrollTo(0,normalizedScroll);
    },800)
  },

  _email : "",
  _emailHasBeenValid : false,
  emailChanged : function(email)
  {
    this._email = email;
    var emailValid = this.props.appManager.isValidEmail(email);
    if( this._emailHasBeenValid && !emailValid && !this.state.emailError )
    {
      this.setState({emailError:true})
    }

    if( emailValid )
    {
      this._emailHasBeenValid = true;
      if( this.state.emailError )
      {
        this.setState({emailError:false});
      }
    }
  },

  _name : "",
  _nameHasSucceeded : false,
  nameChanged : function(text)
  {
    this._name = text;
    var nameError = !this.props.appManager.isNameValid(this._name)
    if( nameError != this.state.nameError && this._nameHasSucceeded )
    {
      this.setState({nameError:nameError});
    }

    if( !nameError ) this._nameHasSucceeded = true;
  },

  _message : "",
  messageChanged : function(message)
  {
    this._message = message;
    this.setState({message:message});
  },

  submitPressed : function()
  {
    var appActions = this.props.appActions;
    var thisThing = this;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = this.props.appManager.currentUser();
    var nameIsValid = this.props.appManager.isNameValid(this._name);
    if( !this.props.appManager.isValidEmail(this._email) )
    {
      this.setState({emailError:true});
      appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
        thisThing._ref_email.focus();
      }], function(){})
    }
    else if( !nameIsValid ) // name error
    {
      this.setState({nameError:true})
      var theirFirstLastNameError = locManager.localizedStringForKey("THEIR_NAME_EMPTY_FAIL_ALERT_BODY", "Please enter recipient's first and last name.");
      appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", theirFirstLastNameError, ["OK_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
        thisThing._ref_name.focus();
      }], function(){})
    }
    else if( this._ref_paymentMethod.getPrimaryPaymentMethod() == null )
    {
      appActions.showLocalizedAlert("SET_PRIMARY_ERROR_ALERT_TITLE", "SET_PRIMARY_ERROR_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
        appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true});
      }], function(){})
    }
    else
    {
      var email = this._email;
      var message = this._message;
      var amount = this._ref_PriceChooserView.getAmount();
      var thisThing = this;
      var confirmTitle = locManager.localizedStringForKey("CONFIRM_ALERT_TITLE", "Confirmation");
      var confirmBody = locManager.localizedStringForKeyAndParams("SEND_CREDIT_CONFIRMATION_BODY", [locManager.localizedDollars(amount),thisThing._name, email],  "Would you like to send %0% to %1% (%2%)?");
      var yesButton = locManager.localizedStringForKey("YES_ALERT_BUTTON");
      var noButton = locManager.localizedStringForKey("NO_ALERT_BUTTON");
      appActions.setSpinnerShown(false);
      appActions.showAlert(confirmTitle,confirmBody,[noButton, yesButton], [function(){appActions.hideAlert()},function(){appActions.hideAlert(); thisThing.send(amount, email, message)}]);
    }
  },

  send : function(amount, email, message)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");

    var {firstName, lastName} = appManager.parseName(this._name);
    var paymentMethod = this._ref_paymentMethod.getPrimaryPaymentMethod();
    appActions.setSpinnerShown(true, processingHUD);
    NetworkManager.sendGiftCard( appManager, amount, email, message, firstName, lastName, paymentMethod, function(data)
    {
      appActions.setSpinnerShown(false);
      var sendSuccess = locManager.localizedStringForKey("SEND_GC_SUCCESS_ALERT_TITLE", "Success!");
      var creditSent = locManager.localizedStringForKey("SEND_GC_SUCCESS_ALERT_BODY", "Your gift card has been sent.");
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      appActions.showAlert(sendSuccess,creditSent,[okayText],[function(){appActions.requestPop(false);appActions.hideAlert();}]);
    },
    function(data)
    {
      var sendFailedTitle = locManager.localizedStringForKey("SEND_GC_FAIL_ALERT_TITLE", "Transaction Failed!");
      var sendFailedBody = locManager.localizedStringForKey("SEND_GC_FAIL_ALERT_BODY", "Your gift card could not be sent.");
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      appActions.setSpinnerShown(false);
      appActions.showAlert(sendFailedTitle,sendFailedBody,[okayText]);
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    })
  },

  didUpdate : function(data)
  {

  },

  didStartChoosingPrice: function()
  {
    this._ref_ptr.setRefreshEnabled(false);
  },

  didEndChoosingPrice: function()
  {
    this._ref_ptr.setRefreshEnabled(true);
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var howMuchCreditToSendStatement = locManager.localizedStringForKey("SEND_GC_AMOUNT_LABEL");
    var howWouldYouLikeToPayStatement = locManager.localizedStringForKey("SEND_GC_METHOD_LABEL");
    var whoToSendStatement = locManager.localizedStringForKey("SEND_GC_RECIPIENT_LABEL");
    var emailLabel = locManager.localizedStringForKey("EMAIL_LABEL");
    var messageLabel = locManager.localizedStringForKey("SEND_GC_MESSAGE_LABEL");
    var sendButton = locManager.localizedStringForKey("SEND_BUTTON");
    var priceChooserProps = {};
    if( typeof this.props.featureData.choiceValue !== 'undefined' )
    {
      priceChooserProps.choiceValue = this.props.featureData.choiceValue;
    }
    if( typeof this.props.featureData.choiceIndex !== 'undefined' )
    {
      priceChooserProps.initialIndex = this.props.featureData.choiceIndex;
    }

    var nameLabel = locManager.localizedStringForKey("SEND_GC_NAME_LABEL");
    var paymentInfo = appManager.getPaymentInfo();
    var hasPrimaryPaymentMethod = false;
    for( var i = 0; i < paymentInfo.length; i++ )
    {
      if( paymentInfo[i].isPrimary )
      {
        hasPrimaryPaymentMethod = true;
        break;
      }
    }
    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} onLayout={(event)=>this._scrollViewHeight = event.nativeEvent.layout.height}>
          <View onLayout={(event)=>this._contentHeight = event.nativeEvent.layout.height}>
            <View style={[styles.instructionContainer, {backgroundColor: instructionColor}]}>
              <View style={{alignSelf:'center'}}>
                <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                  {creditsLeftStatement}
                </ReUpText>
              </View>
              <View style={{flex:1}} />
              <ReUpIconButton type={3}
                appManager={appManager}
                featureData={this.props.featureData}
                appActions={appActions}
                />
            </View>
            <ShadowView layout={this.state.layout} appManager={appManager}/>
            {
              !hasPrimaryPaymentMethod ?
                <View>
                  <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
                    {locManager.localizedStringForKey("SEND_GIFT_CARD_INSTRUCTION")}
                  </ReUpText>
                  <PaymentMethodChooserView ref={(c) => { this._ref_paymentMethod = c; }} style={[styles.paymentMethodContainer,{marginBottom:10}]} appManager={this.props.appManager} appActions={this.props.appActions}
                    initialLayout={this.state.layout} paymentInfo={paymentInfo} {...priceChooserProps} />
                </View>
              :
              <View>
                <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
                  {howMuchCreditToSendStatement}
                </ReUpText>
                <PriceChooserView ref={(c) => { this._ref_PriceChooserView = c; }} style={[styles.choicesContainer,{marginBottom:10}]} appManager={this.props.appManager}
                  initialLayout={this.state.layout} didChangeValueAndText={(v,t)=>thisThing.setState({sendButtonTitle:sendButton+" - "+t})}
                  didStartChoosingPrice={this.didStartChoosingPrice} didEndChoosingPrice={this.didEndChoosingPrice}
                  {...priceChooserProps} />
                <ShadowView layout={this.state.layout} appManager={appManager}/>
                <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
                  {howWouldYouLikeToPayStatement}
                </ReUpText>
                <PaymentMethodChooserView ref={(c) => { this._ref_paymentMethod = c; }} style={[styles.paymentMethodContainer,{marginBottom:10}]} appManager={this.props.appManager} appActions={this.props.appActions}
                  initialLayout={this.state.layout} paymentInfo={paymentInfo} {...priceChooserProps} />
                <View style={{flexDirection:'column', alignItems:'stretch'}}>
                  <ShadowView layout={this.state.layout} appManager={appManager}/>
                  <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
                    {whoToSendStatement}
                  </ReUpText>
                  <ReUpField
                    appManager={appManager}
                    key="email" ref={(c) => { this._ref_email = c; }}
                    autoCapitalize={'none'}
                    keyboardType={'email-address'}
                    onChangeText={this.emailChanged}
                    placeholder={emailLabel}
                    isInError={this.state.emailError}
                    style={[styles.textField,{margin:10, marginTop:0}]}
                    onFocus={()=>this.setScrollOffset(100)}
                    returnKeyType={'next'}
                    onSubmitEditing={() => {thisThing._ref_name.focus()}}/>
                  <ReUpField
                    appManager={appManager}
                    key="name" ref={(c) => { this._ref_name = c; }}
                    autoCapitalize={'words'}
                    onChangeText={this.nameChanged}
                    placeholder={nameLabel}
                    isInError={this.state.nameError}
                    style={[styles.textField,{margin:10, marginTop:0}]}
                    onFocus={()=>this.setScrollOffset(220)}
                    returnKeyType={'next'}
                    onSubmitEditing={() => {thisThing._ref_message.focus()}}/>
                  <ReUpField
                    appManager={appManager}
                    key="message" ref={(c) => { this._ref_message = c; }}
                    onChangeText={this.messageChanged}
                    placeholder={messageLabel}
                    isInError={false}
                    style={[
                      {
                        margin:10,
                        borderWidth:0,
                        borderColor:generalTitleColor,
                        borderBottomWidth:0,
                        height:Math.max(55,this.state.messageHeight),
                        marginTop:0
                      }]}
                    numberOfLines={3}
                    multiline={true}
                    onLayout={(evt)=>
                      {
                        console.log("fieldheight", evt.nativeEvent.layout.height)
                      }}
                    onFocus={()=>this.setScrollOffset(500)}
                    onSubmitEditing={this.submitPressed}/>
                  <ReUpText appManager={appManager} style={[
                    {
                      position:'absolute',
                      borderWidth:0,
                      left:0,
                      right:0,
                      padding:9,
                      opacity:0,
                      margin:10,
                      fontSize:16, fontFamily: 'Arial'
                    }]}
                    onLayout={(evt)=>
                      {
                        thisThing.setState({messageHeight:evt.nativeEvent.layout.height + 5})}
                      } >
                    {this.state.message}
                  </ReUpText>
                  <ReUpButton appManager={appManager} style={[styles.doneButton]} text={this.state.sendButtonTitle}
                    onPress={this.submitPressed} />
                </View>
              </View>
            }
          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',

  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // Payments

  paymentMethodContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:60,
    flex:1,
    alignItems:'center',
    justifyContent:'center'
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:50,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    margin:10,
    alignItems:'center',
    marginLeft:20,
    marginRight:20,
    justifyContent:'center',
  },
  creditCardIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize:26,
    padding:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    padding:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    fontSize:30,
    backgroundColor:'transparent'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0
  },

  textField: {
    width:-1,
    height:50
  },

  dateContainer: {
    flexDirection: 'row',
    alignItems:'flex-end',
    margin:8,
    marginTop:0,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
    marginRight:10, marginLeft:10, marginBottom:10,
  },

  segmentContainer: {
    height:50,
    padding:4,
    flex:1,
    alignSelf:'center'
  }
});

SendGiftCard.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn || typeof ModelConstants === 'undefined' ) return [];
  else
  {
    var user = appManager.currentUser();
    var credit = user[ModelConstants.Credits]
    if( credit < 20) return [];

    var didSelect = function() {appActions.requestFeatureName("SendGiftCard")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 0
    }];
  }
}

SendGiftCard.dataDependencies = ["Users"];

module.exports = SendGiftCard;
